import React, { useState, useEffect } from "react";
import styles from "./OrderAmountBlock.module.css";
import { currencyOptions } from "../../../Settings/Data/lists";
import { Input, InputPicker } from "rsuite";

function OrderAmountBlock({
  showOrderAmountBlock,
  form,
  orderAmountHandler,
  orderAmountCurrencyHandler,
}) {
  // const currencyOptions = [
  //   { label: "USD", value: "USD" },
  //   { label: "EUR", value: "EUR" },
  //   { label: "GBP", value: "GBP" },
  //   { label: "AED", value: "AED" },
  //   { label: "DKK", value: "DKK" },
  //   { label: "CNY", value: "CNY" },
  //   { label: "JPY", value: "JPY" },
  //   { label: "SGD", value: "SGD" },
  //   { label: "TRY", value: "TRY" },
  //   { label: "AUD", value: "AUD" },
  //   { label: "CAD", value: "CAD" },
  //   { label: "CHF", value: "CHF" },
  //   { label: "INR", value: "INR" },
  //   { label: "RUB", value: "RUB" },
  // ];

  //   const getOrderAmount = () => {
  //     if (typeof form?.orderAmount === "string") {
  //       return form.orderAmount;
  //     } else if (
  //       Array.isArray(form?.orderAmount) &&
  //       form.orderAmount.length === 2
  //     ) {
  //       return form.orderAmount[0];
  //     }
  //     return ""; // Or some default value, like '0'
  //   };

  //   const handleCurrencyChange = (value) => {
  //     setCurrency(value);

  //     if (Array.isArray(form?.orderAmount)) {
  //       const newOrderAmount = [getOrderAmount(), value]; // Combine existing amount with the new currency
  //       orderAmountHandler(newOrderAmount);
  //     } else if (typeof form?.orderAmount === "string") {
  //       const newOrderAmount = { amount: getOrderAmount(), currency: value };
  //       orderAmountHandler(newOrderAmount);
  //     }
  //   };

  //   useEffect(() => {
  //     // Initialize currency from form if orderAmount is an array.
  //     if (Array.isArray(form?.orderAmount) && form.orderAmount.length === 2) {
  //       setCurrency(form.orderAmount[1]);
  //     }
  //     // You may also want to handle the case where the form is pre-populated with a string.
  //     //if (typeof form?.orderAmount === 'string') {
  //     //  setCurrency('USD'); // Or use some default currency
  //     //}
  //   }, [form?.orderAmount]);

  return (
    <>
      {showOrderAmountBlock && (
        <div className={styles.order_amount}>
          <div className={styles.order_amount_title}>Order amount:</div>
          <div>
            <Input
              className={styles.order_amount_input}
              onChange={orderAmountHandler}
              value={form?.orderAmount}
              placeholder="Order amount"
              style={{ marginRight: "15px" }} // Add some spacing
            />
          </div>
          <div>
            <InputPicker
              className={styles.order_amount_currency}
              defaultValue={form?.orderAmountCurrency}
              onChange={orderAmountCurrencyHandler}
              value={form?.orderAmountCurrency}
              data={currencyOptions}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default OrderAmountBlock;
